import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/arrow.png'


const _withScopeId = n => (_pushScopeId("data-v-82913e22"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "part-com" }
const _hoisted_2 = { class: "header-row" }
const _hoisted_3 = { class: "part-name" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "part-ename" }, "Party Construction", -1))
const _hoisted_5 = { class: "part-name" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "part-ename",
  style: {"white-space":"nowrap"}
}, "Labor Services", -1))
const _hoisted_7 = { class: "part-name" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "part-ename" }, "Open Governance", -1))
const _hoisted_9 = { class: "nav-wrap" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_12 = { class: "new-list" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "title" }
const _hoisted_15 = { class: "news-des" }
const _hoisted_16 = { class: "foot" }
const _hoisted_17 = { class: "source" }
const _hoisted_18 = { class: "time" }

import { ref, reactive, watch } from "vue";
import { getArticleQuery } from "../../request/api";
import { useRouter } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  __name: 'mutilNewTypeCom',
  props: {
  ColumnData: {
    type: Array, //类型字符串
    default: () => []
  },
  newsIDList: {
    type: Array, //每个组件对应特定的id
    default: () => []
  }
},
  setup(__props) {

const props = __props;

const router = useRouter();
//接收父组件传过来的值,需要注意defineProps只能在setup语法糖里面使用，不需要import引入

let toList = () => {
  router.push({
    path: "/pages/list/list",
    query: {
      level1Id: currentMenu.value.id,
      level2Id: currentMenu.value.children[currentNav.value].id,
      current: 0
    }
  });
};
// 头部菜单
let headNav: number = ref(0);
let currentNav: number = ref(0);
let changeHeadNav = (index: number) => {
  headNav.value = index;
  currentMenu.value = menuList.value[index];
  console.log(
    currentMenu.value,
    currentNav.value,
    "(currentMenu.value,currentNav.value"
  );
  getArticleList();
};
// 栏目列表
let menuList = ref([]);
props.ColumnData.forEach(val => {
  props.newsIDList.forEach(subVal => {
    if (val.id == subVal) {
      menuList.value.push(val);
    }
  });
});
// 访问数据中的数据也要加上。value
console.log(menuList.value[0], "menuList.value");
// 获取当前菜单以及子菜单
let currentMenu = ref({});
currentMenu.value = menuList.value[headNav.value];
// 声名获取列表的函数
let articleList = ref([]);
let getArticleList = () => {
  getArticleQuery({
    pageNum: 1,
    pageSize: 3,
    is_show: 1,
    column_id: currentMenu.value.children[currentNav.value].id,
    title: ""
  }).then(res => {
    articleList.value = res.data.data;
    console.log(articleList.value, "articleList.value");
  });
};
getArticleList();
// 菜单改变
console.log(props.newsID, "newsID");
console.log(props.ColumnData, "ColumnData1111");

let changeNav = (index: number, link: string) => {
  if (link) {
    window.open(link);
  } else {
    currentNav.value = index;
    getArticleList();
  }
};

// props.ColumnData.forEach(val => {
//   if (val.id == props.newsID) {
//     currentMenu.value = val;
//     console.log(currentMenu.value, "currentMenu");
//     getArticleList();
//   }
// });

// 前往文章详情

let articleDetail = item => {
  console.log(item, "id");
  if (item.link_url) {
    let url =
      item.link_url.substr(0, 4) == "http"
        ? item.link_url
        : "http://" + item.link_url;
    window.open(url);
  } else {
    router.push({
      path: "/pages/detail/detail",
      query: {
        id: item.id,
        level1Id: currentMenu.value.id,
        level2Id: currentMenu.value.children[currentNav.value].id
      }
    });
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["header-wrap", _unref(headNav)==0?'activeNav':'']),
        onMouseover: _cache[0] || (_cache[0] = ($event: any) => (_unref(changeHeadNav)(0)))
      }, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(menuList)[0].name), 1),
        _hoisted_4
      ], 34),
      _createElementVNode("div", {
        class: _normalizeClass(["header-wrap", _unref(headNav)==1?'activeNav':'']),
        onMouseover: _cache[1] || (_cache[1] = ($event: any) => (_unref(changeHeadNav)(1)))
      }, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(menuList)[1].name), 1),
        _hoisted_6
      ], 34),
      _createElementVNode("div", {
        class: _normalizeClass(["header-wrap", _unref(headNav)==2?'activeNav':'']),
        onMouseover: _cache[2] || (_cache[2] = ($event: any) => (_unref(changeHeadNav)(2)))
      }, [
        _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(menuList)[2].name), 1),
        _hoisted_8
      ], 34)
    ]),
    _createElementVNode("div", _hoisted_9, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currentMenu).children, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["tab-item", _unref(currentNav)==index?'active-item':'']),
          onClick: ($event: any) => (_unref(changeNav)(index,item.link_url)),
          key: item.id
        }, _toDisplayString(item.name), 11, _hoisted_10))
      }), 128)),
      _createElementVNode("div", {
        class: "more-wrap",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(toList)()))
      }, [
        _createTextVNode("more "),
        _hoisted_11
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(articleList), (Aitem, Aindex) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "news-item",
          onClick: ($event: any) => (_unref(articleDetail)(Aitem)),
          key: Aitem.title
        }, [
          _createElementVNode("div", _hoisted_14, _toDisplayString(Aitem.title), 1),
          _createElementVNode("div", _hoisted_15, _toDisplayString(Aitem?.abstract||""), 1),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, "来源: " + _toDisplayString(Aitem.origin?.name||""), 1),
            _createElementVNode("div", _hoisted_18, "发布时间: " + _toDisplayString(Aitem.start_time.substr(0,10)), 1)
          ])
        ], 8, _hoisted_13))
      }), 128))
    ])
  ]))
}
}

})